import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

interface GranvilleBrandIconProps extends IconWrapperProps {
  variant?: "light" | "dark";
}

/**
 * The supplied artwork is 200.77 x 233.85 — taller than wide, unlike the other
 * brand marks. The square viewBox centres it on (100.39, 116.92) and scales its
 * long axis to the ~71% of the box the other marks fill.
 */
function GranvilleBrandSvg(props: {
  variant?: "light" | "dark";
  className?: string;
}) {
  const variant = props.variant || "light";
  const fillColor = variant === "light" ? "currentColor" : "#44403C";

  return (
    <svg
      className={props.className}
      fill="none"
      role="img"
      viewBox="-64.3 -47.76 329.37 329.37"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Granville</title>
      <path
        d="M37.93,84.22L0,55.77l20.69,113.79c1.04,5.71,4.26,10.79,8.98,14.16l70.18,50.13L37.93,84.22h0Z"
        fill={fillColor}
      />
      <polygon
        fill={fillColor}
        points="100.38 233.21 154.06 85.89 100.38 0 46.7 85.89"
      />
      <path
        d="M162.84,84.22l-61.92,149.63,70.18-50.12c4.72-3.37,7.94-8.45,8.98-14.16l20.69-113.79-37.93,28.45h0Z"
        fill={fillColor}
      />
    </svg>
  );
}

export function IconGranvilleBrand(props: GranvilleBrandIconProps) {
  return (
    <IconWrapper {...props}>
      <GranvilleBrandSvg className={props.className} variant={props.variant} />
    </IconWrapper>
  );
}
